export default __webpack_public_path__ + "static/media/xls.3d3d052f.svg";